module.exports = __webpack_public_path__ + "img/lemon-right-7.2e5f03da.png";